import gql from "graphql-tag";

// fragment
export const SALES_ORDER_FRAGMENT = gql`
    fragment salesOrder on SalesOrderNode {
        id
        salesOrderNo
        note
        customer {
            id
            name
        }
        orderStatus
        orderStatusDate
        deliverDatePlanned
        orderCreatedDate
        readyToPickDate
        pickedDate
        closedDate
        totalProductQuantity
    }
`;

// single fragment
export const SINGLE_SALES_ORDER_FRAGMENT = gql`
    fragment salesOrderFull on SalesOrderNode {
        id
        salesOrderNo
        note
        customer {
            id
            name
        }
        orderStatus
        orderStatusDate
        deliverDatePlanned
        orderCreatedDate
        readyToPickDate
        pickedDate
        closedDate
        totalProductQuantity
        salesOrderProductSet {
            totalCount
            edges {
                node {
                    id
                    product {
                        id
                        name
                        isDynamic
                    }
                    quantity
                    salesOrderPlantSet {
                        totalCount
                        edges {
                            node {
                                id
                                plant {
                                    id
                                    name
                                }
                                color {
                                    id
                                    color
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                quantity
                                salesOrderGrowthTaskSet {
                                    totalCount
                                    edges {
                                        node {
                                            id
                                            growthTask {
                                                id
                                                growthTaskPhaseSet(
                                                    isCurrentPhase: true
                                                ) {
                                                    edges {
                                                        node {
                                                            id
                                                            greenhouseDepartmentSection {
                                                                id
                                                                name
                                                                greenhouseDepartment {
                                                                    id
                                                                    name
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            quantity
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

// all orders query
export const ALL_SALES_ORDERS_QUERY = gql`
    query {
        tenantAllSalesOrders(first: 10, orderBy: "deliverDatePlanned") {
            edges {
                node {
                    ...salesOrder
                }
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// active orders query
export const ACTIVE_SALES_ORDERS_QUERY = gql`
    query {
        tenantActiveSalesOrders(orderBy: "deliverDatePlanned") {
            edges {
                node {
                    ...salesOrder
                }
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// picklist query
export const SALES_ORDERS_PICKLIST_QUERY = gql`
    query {
        tenantSalesOrderPicklist(orderBy: "deliverDatePlanned") {
            edges {
                node {
                    ...salesOrder
                }
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// single query
export const SINGLE_SALES_ORDER_QUERY = gql`
    query SalesOrder($id: ID!) {
        salesOrder(id: $id) {
            ...salesOrderFull
        }
    }
    ${SINGLE_SALES_ORDER_FRAGMENT}
`;

// create
export const CREAT_SALES_ORDER_MUTATION = gql`
    mutation createSalesOrder($input: CreateSalesOrderInput!) {
        createSalesOrder(input: $input) {
            SalesOrder {
                ...SalesOrder
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// update
export const UPDATE_SALES_ORDER_MUTATION = gql`
    mutation updateSalesOrder($input: UpdateSalesOrderInput!) {
        updateSalesOrder(input: $input) {
            SalesOrder {
                ...SalesOrder
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// update SalesOrder items
export const UPDATE_SALES_ORDER_ITEMS_MUTATION = gql`
    mutation updateSalesOrderItems($input: UpdateSalesOrderItemsInput!) {
        updateSalesOrderItems(input: $input) {
            SalesOrder {
                ...SalesOrder
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;

// delete
export const DELETE_SALES_ORDER_MUTATION = gql`
    mutation deleteSalesOrder($input: DeleteSalesOrderInput!) {
        deleteSalesOrder(input: $input) {
            SalesOrder {
                ...SalesOrder
            }
        }
    }
    ${SALES_ORDER_FRAGMENT}
`;
